import { EyeOutlineIcon } from './EyeOutlineIcon';

/**
 * author: Austin Andrews
 * id F2AA59FA-23F6-4FE8-A52A-AEC674A9E864
 * name eye-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-outline.svg
 * tags
 */
export const VisibilityOutlineIcon = EyeOutlineIcon;
export default VisibilityOutlineIcon